module.exports = __webpack_public_path__ + "img/platform_001.e2ae0272.png";